module.exports = __webpack_public_path__ + "fdd852f57393356bad7f52650ca05584.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/new_owl_2.png
// module id = 1153
// module chunks = 0